const Cancel = function () {
  this.addRole.hideModal()
  this.addRole.resetAddRoleModal()
}

export default Cancel
